import React from "react";

const Details = ({ rowData }) => {
  const fields = [
    { label: "Name", key: "name" },
    { label: "User Name", key: "username" },
    { label: "Email", key: "email" },
    { label: "Mobile Number", key: "mobileNumber" },
    // { label: "Password", key: null, value: "*******" },
    { label: "Alert Preference", key: "alertPreferences" },
    { label: "Role", key: "roleName" },
    { label: "Status", key: "isActive", value: rowData?.isActive ? "Active" : "Inactive" },
    { label: "Branch", key: "branchName" },
  ];

  return (
    <div className="main-form form-details">
      <div className="p-fluid formgrid grid">
        {fields.map(({ label, key, value }) => (
          <div key={label} className="field col-12 md:col-4 mb-3">
            <label>{label}</label>
            <p>{value ?? rowData?.[key] ?? "N/A"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
